export function getRandomQuestion() {
  const operations = ["+", "-", "×"];
  const op = operations[Math.floor(Math.random() * operations.length)];
  const a = Math.floor(Math.random() * 10) + 1;
  const b = Math.floor(Math.random() * 10) + 1;

  let answer;
  switch (op) {
    case "+":
      answer = a + b;
      break;
    case "-":
      answer = a - b;
      break;
    case "×":
      answer = a * b;
      break;
  }

  const options = new Set([answer]);
  while (options.size < 4) {
    options.add(Math.floor(Math.random() * 20) + 1);
  }

  return {
    question: `${a} ${op} ${b} = ?`,
    answer,
    options: Array.from(options).sort(() => 0.5 - Math.random()),
  };
}
